import React from 'react'
import { useTranslation } from 'react-i18next'
import { WarningOutlined } from '@ant-design/icons'

import { useError } from '../../contexts/error-context'

import './index.css'

export default function NotFound() {
    const errorContext = useError()
    const { t } = useTranslation()

    console.log('error context', errorContext)

    const GetErrorTitle = () => {
        if (errorContext.error?.type == 401) {
            return t('This page is currently not published')
        }
        if (
            errorContext.error?.type == 404 &&
            errorContext.error?.PUBLISH_TYPES &&
            errorContext.error?.published !== undefined
        ) {
            return t(
                'Le {{PUBLISH_TYPES}} de cet événement n’est pas publié ! Veuillez vous rapprocher de l’organisateur.',
                { PUBLISH_TYPES: errorContext.error?.PUBLISH_TYPES.toLowerCase() },
            )
        }
        if (errorContext.error?.type == 404) {
            return t('Page not found')
        }
        if (errorContext.error) {
            return t('Oops, an error occurred !')
        }
        return t('Page not found')
    }

    const GetErrorMessage = () => {
        if (errorContext.error?.type == 404 && errorContext.error?.location?.pathname) {
            return <h2>{errorContext.error.location.pathname}</h2>
        }
        if (errorContext.error?.type == 401 && errorContext.error?.open_date) {
            return <h2>{t('Start date: {{date}}', { date: errorContext.error?.open_date })}</h2>
        }
        return ''
    }

    return (
        <div className="not-found-container">
            <h1>
                {GetErrorTitle()} <WarningOutlined />
            </h1>
            {GetErrorMessage()}
        </div>
    )
}

